import { notify } from '@/utils/notify';
import axios from 'axios';
import { attachTokenRefresh } from '@/utils/authInterceptors';
import { CLOUD_SERVICE_BASE_URL } from '@/utils/const';
import { v4 as uuidv4 } from 'uuid';

const patientListService = axios.create({
  baseURL: CLOUD_SERVICE_BASE_URL + (process.env.VUE_APP_ENV === "production" 
    ? "/portal/trans-service/" 
    : "/portal/trans-service-st/"
)
});

patientListService.interceptors.request.use(
  async function(config) {
    // Get JWT token from session storage (same as used in the working request)
    let token = sessionStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    
    // Set default headers
    let XRequestID = uuidv4();
    config.headers['Content-Type'] = 'application/json';
    config.headers['X-Request-ID'] = XRequestID;
    
    return config;
  },
  function(error) {
    return Promise.reject(error);
  }
);

patientListService.interceptors.response.use(
  response => {
    return response;
  },
  error => {
    console.error('Patient API Error:', error);
    
    // error handling
    let message = 'An error occurred while fetching patient data';
    if (error.response) {
      message = error.response.data?.message || `Server Error: ${error.response.status}`;
    } else if (error.request) {
      message = 'Network error - please check your connection';
    }
    
    notify({
      title: "Error",
      message: message,
      type: "error",
      duration: 5000,
    });
    
    return Promise.reject(error);
  }
);

attachTokenRefresh(patientListService);

export default patientListService;
